import { type FC, type ReactNode, useMemo, type PropsWithChildren, useState, useEffect } from 'react';
import {
  UiHStack,
  UiStack,
  uiStyles,
  UiImage
} from '@/lib/ui';
import Header from './Header';
import HeaderWithCart from './HeaderWithCart';
import EventInfo from './EventInfo';
import { useRegisterRoute } from '@/registration/hook/useRegisterRoute';
import { useEventQuery } from '@/registration/hook/useEventQuery';
import { getAppConfig } from '@/app/config';
import { useWindowScrollY, useWindowSize } from '@/lib/hook';
import { topNavHeight } from '@/base/Layout/viewport';
import { ShoppingCartToggleProvider } from '@/registration/component/Register/ShoppingCart/ShoppingCartToggleProvider';
import { LocaleProvider } from '@/registration/component/Locale/LocaleProvider';

export interface StoreLayoutProps extends PropsWithChildren {
  header?: ReactNode
  enableHeader?: boolean
  children: ReactNode
  showShoppingCart?: boolean
}

// const topNavMaxHeight = 72;

const StoreLayout: FC<StoreLayoutProps> = ({
  children,
  header,
  enableHeader = true,
  showShoppingCart = true,
}) => {
  // const [topNavOpacity, setTopNavOpacity] = useState(1);
  // const [topNavScale, setTopNavScale] = useState(1);
  // const [topNavHeight, setTopNavHeight] = useState(topNavMaxHeight);
  const windowScrollY = useWindowScrollY();
  const { eventId } = useRegisterRoute();
  // const { displayShoppingCart } = useRegisterSteps();
  const app = getAppConfig();
  const { data: event } = useEventQuery(eventId);
  const { clientWidth: windowClientWidth } = useWindowSize();
  const registrationBanner = useMemo(() => {
    // Backend should always return the aboslute URL since in production, the url will be the CloudFront url.
    return event?.registrationBanner ?? '';
  }, [event]);

  // useEffect(
  //   () => {
  //     // setTopNavOpacity(1 - 2 * windowScrollY / topNavMaxHeight);
  //     // setTopNavScale(Math.max(1 - (0.15 * windowScrollY) / topNavMaxHeight, 1));
  //     // setTopNavHeight(Math.max(topNavMaxHeight - windowScrollY, topNavMaxHeight - 32));
  //   },
  //   [
  //     windowScrollY
  //   ]
  // );

  const bodyWidth = useMemo(
    () => {
      return Math.min((windowClientWidth - 32), 1280);
    },
    [windowClientWidth]
  );

  // const DefaultHeader = useMemo(() => {
  //   return displayShoppingCart ? <HeaderWithCart /> : <Header />;
  // }, [displayShoppingCart]);

  return (
    <ShoppingCartToggleProvider>
      <UiStack
        // p={{base: 4, md: 8}}
        minHeight={'100vh'}
        alignItems={'stretch'}
        bgColor={'gray.100'}
        borderRadius={uiStyles.borderRadius}
        spacing={0}
        flexGrow={1}
        // bgGradient={'radial(indigo.50, gray.200)'}
        // bgGradient={'linear(150deg, primary.50 10%, indigo.50 30%, gray.200 100%)'}
      >
        {enableHeader && (
          <UiStack
            position={'fixed'}
            minH={`${topNavHeight}px`}
            maxH={`${topNavHeight}px`}
            width={'100%'}
            // bgColor={'red'}
            alignItems={'stretch'}
            bgColor={'#fff'}
            // opacity={topNavOpacity}
            // transform={`scale(${topNavScale})`}
            zIndex={99}
            shadow={windowScrollY > 2 ? 'md' : 'none'}
            borderBottomRadius={windowScrollY > 2 ? uiStyles.borderRadius : 0}
            // bgGradient={'radial(100% 100% at 0% 35%, brand.50 20%, gray.200 80%, gray.200 100%)'}
          >
            {header ?? (showShoppingCart ? (<HeaderWithCart />) : (<Header />))}
          </UiStack>
        )}
        <UiStack
          alignItems={'stretch'}
          flexGrow={1}
          bgColor={'gray.100'}
          mt={enableHeader ? `${topNavHeight}px` : undefined}
          spacing={0}
          // zIndex={99}
        >
          {/* <UiHStack */}
          {/*  justifyContent={'space-around'} */}
          {/*  alignItems={'flex-start'} */}
          {/*  px={{base: 6, lg: 8}} */}
          {/* > */}
          {/*  <UiStack */}
          {/*    // minW={600} */}
          {/*    maxW={`${bodyWidth}px`} */}
          {/*    flexGrow={1} */}
          {/*    overflowX={'hidden'} */}
          {/*    // py={{base: 8, md: 8}} */}
          {/*  > */}
          {/*    <EventInfo /> */}
          {/*  </UiStack> */}
          {/* </UiHStack> */}
          <UiStack
            // p={{base: 8}}
            // px={{base: 6, lg: 8}}
            py={{base: 4, lg: 8}}
            px={{ base: 4, lg: 8 }}
            // pt={{ base: 8, lg: 8 }}
            // pb={8}
            spacing={0}
            flexGrow={1}
            alignItems={'stretch'}
            bgColor={'whiteAlpha.600'}
          >
            <UiHStack flexGrow={1} justifyContent={'space-around'} alignItems={'flex-start'}>
              <UiStack
                // minW={600}
                maxW={`${bodyWidth}px`}
                flexGrow={1}
                overflowX={'hidden'}
                // py={{base: 8, md: 8}}
              >
                <UiStack
                  spacing={0}
                  borderRadius={uiStyles.borderRadius}
                  bgColor={'#fff'}
                  borderColor={'gray.200'}
                  borderWidth={'1px'}
                  borderStyle={'solid'}
                >
                  {registrationBanner && (
                    <UiStack borderTopRadius={uiStyles.borderRadius}>
                      <UiImage
                        src={registrationBanner ?? ''}
                        // maxHeight={'400px'}
                        objectFit={'contain'}
                        borderTopRadius={uiStyles.borderRadius}
                      />
                    </UiStack>
                  )}
                  <EventInfo />
                </UiStack>
                <UiStack height={8}/>
                <UiStack px={1}>
                  {children}
                </UiStack>
              </UiStack>
            </UiHStack>
          </UiStack>
        </UiStack>
        {/* Override brand footer */}
        {/* <Footer /> */}
      </UiStack>
    </ShoppingCartToggleProvider>
  );
};

export default StoreLayout;
